import update from 'immutability-helper';

import {findIndex} from 'utils';

import {ManageOrganizationState, ManageOrganizationActionType} from './types';
import {
  LOAD_ORGANIZATIONS_SUCCESS,
  LOAD_ORGANIZATIONS_FAILURE,
  LOAD_ORGANIZATIONS_REQUEST,
  ADD_ORGANIZATION_FAILURE,
  ADD_ORGANIZATION_SUCCESS,
  EDIT_ORGANIZATION_FAILURE,
  EDIT_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_SUCCESS,
  DOWNLOAD_RESULTS_FAILURE,
} from './actions';

const initialState: ManageOrganizationState = {};

export default function manageOrganizationReducer(
  state = initialState,
  action: ManageOrganizationActionType
): ManageOrganizationState {
  const {type, payload} = action;

  switch (type) {
    case LOAD_ORGANIZATIONS_REQUEST:
      return update(state, {
        $merge: {
          loading: true,
          data: undefined,
          error: undefined,
        },
      });
    case LOAD_ORGANIZATIONS_SUCCESS:
      return update(state, {
        loading: {$set: false},
        data: {$set: payload.data},
      });
    case ADD_ORGANIZATION_SUCCESS:
      return update(state, {
        data: {
          $set: payload.selectedOrganization
            ? [payload.selectedOrganization, ...(state.data || [])]
            : state.data,
        },
      });
    case EDIT_ORGANIZATION_SUCCESS: {
      if (!payload.selectedOrganization) {
        return state;
      }

      const index = findIndex(state.data, payload.selectedOrganization);

      if (index < 0) {
        return state;
      }

      return update(state, {
        data: {[index]: {$set: payload.selectedOrganization}},
      });
    }
    case DELETE_ORGANIZATION_SUCCESS: {
      const index = findIndex(state.data, payload.selectedOrganization);

      if (index < 0) {
        return state;
      }

      return update(state, {
        data: {$splice: [[index, 1]]},
      });
    }
    case LOAD_ORGANIZATIONS_FAILURE:
      return {...state, error: payload.error, loading: false};
    case ADD_ORGANIZATION_FAILURE:
      return {...state, error: payload.error, loading: false};
    case EDIT_ORGANIZATION_FAILURE:
      return {...state, error: payload.error, loading: false};
    case DOWNLOAD_RESULTS_FAILURE:
      return update(state, {
        loading: {$set: false},
        error: {$set: payload.error},
      });
    default:
      return state;
  }
}
